export const flex = (value = 1, rest = {}) => ({ style: { display: 'flex', flex: value, ...rest } })
